import { object } from "prop-types";
import { useTranslation } from "react-i18next";
import { Tag } from "@components";
import { Grid } from "@material-ui/core";

export const CellSettingsTitle = ({
  element,
  workType,
}) => {
  const { t } = useTranslation();

  return (
    <Grid container direction="column">
      <h2>{t("views.editor.cell_settings.title")}</h2>
      <Grid item container className="mt-1" spacing={1}>
        <Grid item>
          <Tag
            maxWidth={260}
            ellipsisOnOverflow
            text={element.name || t("common.unnamed")}
          />
        </Grid>
        <Grid item>
          {
            workType
              ? <Tag
                text={workType.name}
                color={workType?.color}
              />
              : <Tag text={t("proposal_parts.row_types.fixedPrice")} />
          }
        </Grid>
      </Grid>
    </Grid>
  );
};

CellSettingsTitle.propTypes = {
  element: object.isRequired,
  workType: object,
};
